import { DataUtils } from '@/core/utils'

export default class atualizarAtaInput {
	inicioValidade
	fimValidade
	isPermiteAdesao
	doe
	idContratacaoPncp
	numeroIdentificacaoProcesso
	idContratado
	dataAssinatura

	constructor(ataInfo) {
		this.inicioValidade = DataUtils.setDateTimeOffSetFromDate(ataInfo.inicioValidade)
		this.fimValidade = DataUtils.setDateTimeOffSetFromDate(ataInfo.fimValidade)
		this.isPermiteAdesao = ataInfo.isPermiteAdesao
		this.doe = ataInfo.doe
		this.idContratacaoPncp = ataInfo.idContratacaoPncp
		this.numeroIdentificacaoProcesso = ataInfo.numeroIdentificacaoProcesso
		this.idContratado = ataInfo.idContratado
		this.dataAssinatura = DataUtils.setDateTimeOffSetFromDate(ataInfo.dataAssinatura)
	}
}
